export enum ListItemTagsEvents {
  clickIconInfoFreeSubscription = 'click_icon_info_free_subscription',
  clickIconInfoCompanyAdditionalCompensation = 'click_icon_info_company_additional_compensation',
  clickIconInfoAdditionalCompensation = 'click_icon_info_additional_compensation',
  clickIconInfoCompanyPointsDiscount = 'click_icon_info_company_points_discount',
}
